import React, { useEffect } from "react";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { useAdminPanelLayoutConfig } from "features/AdminPanel/modules/AdminPanelLayout/utils/useAdminPanelLayoutConfig";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { ADMIN_PANEL_SETTINGS_TITLE } from "features/AdminPanel/constants/AdminPanel.constants";
import { useAdminPanelSettings } from "features/AdminPanel/modules/utils/useAdminPanelSettings";
import { ACCOUNT_FEATURE_KEY } from "features/Account/Account.constants";
import { app_route_ids, app_route_keys } from "constants/urlPaths";

export const MyAdminPanelWrapper = ({
  children,
  hideChildren,
  hideNav,
  hideHeader,
  classes = {},
  featureKey,
  headerTitle,
  headerRight,
  backUrl,
}) => {
  const isDesktop = useDesktopMediaQuery();
  const adminPanelSettingsConfig = useAdminPanelStore(
    (state) => state.adminPanelSettingsConfig
  );

  // added here because feature key is not available in AdminPanelLayout
  const getBackUrl = () => {
    if (backUrl) {
      return backUrl;
    } else {
      if (featureKey === ACCOUNT_FEATURE_KEY) {
        return app_route_ids[app_route_keys.app_home];
      } else {
        return null;
      }
    }
  };

  const { fetchAdminPanelSettings } = useAdminPanelSettings();

  useEffect(() => {
    if (!hideNav) fetchAdminPanelSettings({ key: featureKey });
  }, [hideNav, featureKey]);

  useAdminPanelLayoutConfig({
    config: {
      headerTitle: headerTitle ?? ADMIN_PANEL_SETTINGS_TITLE,
      sideBarConfig: adminPanelSettingsConfig[featureKey],
      hideHeader: hideHeader ?? !isDesktop,
      hideNav: hideNav ?? !isDesktop,
      hideChildren,
      classes: classes,
      headerRight: headerRight,
      backUrl: getBackUrl(),
    },
  });

  return <>{children}</>;
};
